import React from "react";
import { useQualityControl } from "./useQualityControl";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import { constantNoMesin } from "../../util/constant";
import "./QualityControl.css"; // CSS lama, jangan diubah/dihapus

const SUB_MENUS = [
  { key: "dataBerat", label: "Data Berat" },
  { key: "dataTopPlate", label: "Data TopPlate" },
  { key: "detailProduk", label: "Detail Produk" },
];

const sortByMesin = (a, b) => Number(a.mesin) - Number(b.mesin);

// Satu blok label + input/select
const Field = ({ label, required, id, children }) => (
  <div className="qc_field" id={id}>
    <p className="qc_label">
      {label} {required && <b className="qc_required">*</b>}
    </p>
    {children}
  </div>
);

// Tombol Kirim (rata kanan)
const SubmitRow = ({ onClick }) => (
  <div className="qc_submit_row">
    <button className="qc_btn_primary" onClick={onClick}>
      Kirim
    </button>
  </div>
);

// Input angka + satuan "gr"
const WeightInput = ({ className = "", ...props }) => (
  <div className="qc_unit">
    <input
      className={`qc_input qc_input_weight ${className}`}
      type="number"
      onWheel={(e) => e.target.blur()}
      {...props}
    />
    <span>gr</span>
  </div>
);

const QualityControl = () => {
  const {
    listProduk,
    handleFormChange,
    handleKirimQc,
    shift,
    setShift,
    popUpQC,
    setPopUpQC,
    popUpMessage,
    subMenuQc,
    setSubMenuQc,
    noMesinQc,
    setNoMesinQc,
    customerQc,
    setCustomerQc,
    moldQc,
    setMoldQc,
    beratTopPlate,
    setBeratTopPlate,
    handleKirimTopPlate,
    errorMessage,
    dataCavity,
    handleFormChangeCavity,
    setBeratToco,
    setBeratRunner,
    moldPick,
    setMoldPick,
    handleKirimDetailProduk,
    beratToco,
    beratRunner,
  } = useQualityControl();

  // Sort in-place (sengaja): index di handleFormChange harus sama dengan listProduk
  const sortData = listProduk && listProduk.sort(sortByMesin);

  return (
    <div className="qc_root">
      {popUpQC && (
        <PopUpComponent>
          <p>{popUpMessage}</p>
          <div className="qc_popup_footer">
            <button
              className="qc_btn_primary"
              onClick={() => setPopUpQC(false)}
            >
              OK
            </button>
          </div>
        </PopUpComponent>
      )}

      <div className="qc_card">
        <p className="qc_title">Quality Control</p>

        <div className="qc_tabs">
          {SUB_MENUS.map((menu) => (
            <p
              key={menu.key}
              className={
                subMenuQc === menu.key ? "qc_tab qc_tab_active" : "qc_tab"
              }
              onClick={() => setSubMenuQc(menu.key)}
            >
              {menu.label}
            </p>
          ))}
        </div>

        {errorMessage && <p className="qc_error">Mohon Mengisi Semua Kolom!</p>}

        <Field label="Pilih Shift" required id="selectShift">
          <select
            className="qc_select qc_select_shift"
            value={shift}
            onChange={(e) => setShift(e.target.value)}
          >
            <option value="Pilih Shift" disabled>
              Pilih Shift
            </option>
            <option value="1">Shift 1</option>
            <option value="2">Shift 2</option>
            <option value="3">Shift 3</option>
          </select>
        </Field>

        {/* ===================== DATA BERAT ===================== */}
        {subMenuQc === "dataBerat" && (
          <>
            <div className="qc_table_wrapper">
              <table className="qc_table">
                <thead>
                  <tr>
                    <th>Mc</th>
                    <th>Cust</th>
                    <th>Mold</th>
                    <th>Color</th>
                    <th>Runner</th>
                    <th>Berat (gr)</th>
                  </tr>
                </thead>
                <tbody>
                  {sortData &&
                    sortData.map((data, index) => (
                      <tr key={index}>
                        <td className="qc_td_mesin">{data.mesin}</td>
                        <td>{data.customer}</td>
                        <td
                          className="qc_td_mold"
                          style={{ textAlign: "left" }}
                        >
                          {data.moldType}
                        </td>
                        <td>{data.color}</td>
                        <td className="qc_td_input">
                          <WeightInput
                            name="runnerQc"
                            value={data.runnerQc}
                            onChange={(e) => handleFormChange(index, e, "BAKU")}
                            placeholder="Runner"
                          />
                        </td>
                        <td className="qc_td_input">
                          <WeightInput
                            name="beratQc"
                            value={data.beratQc}
                            onChange={(e) => handleFormChange(index, e, "BAKU")}
                            placeholder="Berat"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <SubmitRow onClick={() => handleKirimQc()} />
          </>
        )}

        {/* ===================== TOP PLATE ===================== */}
        {subMenuQc === "dataTopPlate" && (
          <>
            <Field label="Pilih Mesin">
              <select
                className="qc_select qc_full"
                value={noMesinQc}
                onChange={(e) => setNoMesinQc(e.target.value)}
              >
                <option value="Pilih Mesin" disabled>
                  Pilih Mesin
                </option>
                {constantNoMesin &&
                  constantNoMesin.map((data) => (
                    <option key={data} value={data}>
                      {data}
                    </option>
                  ))}
              </select>
            </Field>

            <Field label="Pilih Customer">
              <select
                className="qc_select qc_full"
                value={customerQc}
                onChange={(e) => setCustomerQc(e.target.value)}
              >
                <option value="Pilih Customer" disabled>
                  Pilih Customer
                </option>
                {["GS", "TBP", "YBI", "CBI", "MELCO", "TIM"].map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </Field>

            <Field label="Pilih Mold" required>
              <select
                className="qc_select qc_full"
                value={moldQc}
                onChange={(e) => setMoldQc(e.target.value)}
              >
                <option value="Pilih Mold" disabled>
                  Pilih Mold
                </option>
                {listProduk &&
                  listProduk
                    .filter((obj) => obj.customer === customerQc)
                    .map((obj, i) => (
                      <option key={`${obj.moldType}-${i}`} value={obj.moldType}>
                        {obj.moldType}
                      </option>
                    ))}
              </select>
            </Field>

            <Field label="Berat (gr)">
              <input
                className="qc_input qc_full"
                placeholder="Masukkan Berat"
                type="number"
                value={beratTopPlate}
                onChange={(e) => setBeratTopPlate(e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
            </Field>

            <SubmitRow onClick={() => handleKirimTopPlate()} />
          </>
        )}

        {/* ===================== DETAIL PRODUK ===================== */}
        {subMenuQc === "detailProduk" && (
          <>
            <Field label="Pilih Mold" required>
              <select
                className="qc_select qc_full"
                value={moldPick}
                onChange={(e) => setMoldPick(e.target.value)}
              >
                <option value="Pilih Mold" disabled>
                  Pilih Mold
                </option>
                {sortData &&
                  sortData.map((data, i) => (
                    <option key={`${data.moldType}-${i}`} value={data.moldType}>
                      Mc {data.mesin} - {data.moldType}
                    </option>
                  ))}
              </select>
            </Field>

            <Field label="Berat Per-Cavity (gr)" required>
              <div className="qc_cavity_grid">
                {dataCavity &&
                  dataCavity.map((e, index) => (
                    <div className="qc_cavity_item" key={e.cavity}>
                      <p className="qc_cavity_label">Cav {e.cavity}</p>
                      <input
                        className="qc_input qc_cavity_input"
                        type="number"
                        name="berat"
                        value={e.berat}
                        onChange={(ev) => handleFormChangeCavity(index, ev)}
                        placeholder="Berat"
                        onWheel={(ev) => ev.target.blur()}
                      />
                    </div>
                  ))}
              </div>
            </Field>

            <div className="qc_two_col">
              <Field label="Berat Toco">
                <WeightInput
                  className="qc_input_wide"
                  value={beratToco}
                  onChange={(e) => setBeratToco(e.target.value)}
                  placeholder="Berat"
                />
              </Field>
              <Field label="Berat Runner" required>
                <WeightInput
                  className="qc_input_wide"
                  value={beratRunner}
                  onChange={(e) => setBeratRunner(e.target.value)}
                  placeholder="Berat"
                />
              </Field>
            </div>

            <SubmitRow onClick={() => handleKirimDetailProduk()} />
          </>
        )}
      </div>
    </div>
  );
};

export default QualityControl;
